import React from 'react';
import * as styles from './Column.module.scss';
const CLASSNAME_PREFIX = 'col';
const CLASSNAME_OFFSET = 'offset';
const BREAKPOINTS_NAME = {
  xs: 'Xs',
  sm: 'Sm',
  lg: 'Lg',
  xl: 'Xl'
};
const getColumn = cols => {
  let classes = [];
  Object.getOwnPropertyNames(cols).forEach(key => {
    if (BREAKPOINTS_NAME[key]) {
      let number = null;
      let offset = null;
      const breakpoint = cols[key];
      if (typeof breakpoint === 'object') {
        number = breakpoint.col;
        if (breakpoint.offset >= 0) {
          offset = breakpoint.offset;
        }
      } else if (typeof breakpoint === 'number') {
        number = breakpoint;
      }
      if (number) {
        classes.push(styles[`${CLASSNAME_PREFIX}${number}${BREAKPOINTS_NAME[key]}`]);
      }
      if (offset >= 0) {
        classes.push(styles[`${CLASSNAME_PREFIX}${CLASSNAME_OFFSET}${offset}${BREAKPOINTS_NAME[key]}`]);
      }
    }
  });
  return classes.join(' ');
};
const Column = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    as: Component = 'div',
    children,
    classname,
    ...cols
  } = _ref;
  return /*#__PURE__*/React.createElement(Component, {
    ref: ref,
    className: `${styles.col} ${classname ? classname : ''} ${getColumn(cols)}`
  }, children);
});
Column.displayName = 'Column';
export default Column;